<div class="pm-overlay" [class.open]="showProfileModal()" (click)="closed.emit()"></div>
<div class="pm" [class.open]="showProfileModal()" (click)="$event.stopPropagation()">

  <!-- Header row: avatar left + name + close btn right -->
  <div class="pm-top">
    <div class="pm-top-left">
      <div class="pm-avatar-wrap">
        @if (profileAvatarUrl()) {
          <img [src]="profileAvatarUrl()" [alt]="'USER.AVATAR' | translate" class="pm-avatar-img">
        } @else {
          <div class="pm-avatar-initials">{{ port().getProfileInitials() }}</div>
        }
        <input type="file" #profileFileInput (change)="photoSelected.emit($event)" accept="image/*" style="display:none">
        <button class="pm-avatar-edit" (click)="profileFileInput.click()">
          <i class="pi pi-camera"></i>
        </button>
      </div>
      <div class="pm-top-info">
        <h2 class="pm-name">{{ currentUser()?.name || ('USER.TITLE' | translate) }}</h2>
        <span class="pm-role">{{ selectedCompany() || 'StockFlow' }}</span>
      </div>
    </div>
    <button class="pm-close" (click)="closed.emit()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>
  </div>

  <div class="pm-divider"></div>

  <!-- 2-column grid body -->
  <div class="pm-body">
    <!-- LEFT column -->
    <div class="pm-col">
      <div class="pm-field">
        <label><i class="pi pi-envelope"></i> {{ 'USER.EMAIL' | translate }}</label>
        <input type="email" class="pm-input" [(ngModel)]="profileEmail" />
      </div>

      <div class="pm-field">
        <label><i class="pi pi-phone"></i> {{ 'USER.PHONE' | translate }}</label>
        <input type="tel" class="pm-input" [(ngModel)]="profilePhone" [placeholder]="'USER.PHONE_PLACEHOLDER' | translate" />
      </div>

      <div class="pm-row-2">
        <div class="pm-field">
          <label><i class="pi pi-globe"></i> {{ 'COMPANY.LANGUAGE' | translate }}</label>
          <div class="pm-custom-select" (click)="pmLangOpen.set(!pmLangOpen()); pmThemeOpen.set(false); $event.stopPropagation()">
            <span class="pm-cs-flag">{{ currentLanguage()?.flag }}</span>
            <span class="pm-cs-label">{{ currentLanguage()?.label }}</span>
            <i class="pi pi-chevron-down pm-cs-arrow" [class.open]="pmLangOpen()"></i>
            @if (pmLangOpen()) {
              <div class="pm-cs-dropdown">
                @for (lang of languages(); track lang.code) {
                  <div class="pm-cs-option" [class.active]="lang.code === currentLang()"
                       (click)="languageSelected.emit(lang.code); pmLangOpen.set(false); $event.stopPropagation()">
                    <span class="pm-cs-flag">{{ lang.flag }}</span>
                    <span>{{ lang.label }}</span>
                    @if (lang.code === currentLang()) {
                      <i class="pi pi-check pm-cs-check"></i>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>

        <div class="pm-field">
          <label><i class="pi pi-palette"></i> {{ 'COMMON.CHANGE_THEME' | translate }}</label>
          <div class="pm-custom-select" (click)="pmThemeOpen.set(!pmThemeOpen()); pmLangOpen.set(false); $event.stopPropagation()">
            <div class="pm-cs-dot" [ngClass]="'sw-' + activeTheme()[0]"></div>
            <span class="pm-cs-label">{{ activeThemeLabel() | translate }}</span>
            <i class="pi pi-chevron-down pm-cs-arrow" [class.open]="pmThemeOpen()"></i>
            @if (pmThemeOpen()) {
              <div class="pm-cs-dropdown">
                @for (theme of themes(); track theme.id) {
                  <div class="pm-cs-option" [class.active]="theme.id === activeTheme()"
                       (click)="themeSelected.emit(theme.id); pmThemeOpen.set(false); $event.stopPropagation()">
                    <div class="pm-cs-dot" [ngClass]="'sw-' + theme.id[0]"></div>
                    <span>{{ theme.label | translate }}</span>
                    @if (theme.id === activeTheme()) {
                      <i class="pi pi-check pm-cs-check"></i>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>

      @if (port().availableWarehouses.length > 0) {
        <div class="pm-field">
          <label><i class="pi pi-warehouse"></i> {{ 'WAREHOUSE.SELECT_WAREHOUSE' | translate }}</label>
          <select class="pm-select" (change)="$event.target && ($any($event.target).value === '' ? warehouseCleared.emit() : warehouseSelected.emit(port().availableWarehouses[$any($event.target).value]))">
            <option value="" [selected]="!port().warehouseService.currentWarehouseId()">{{ 'WAREHOUSE.ALL_WAREHOUSES' | translate }}</option>
            @for (wh of port().availableWarehouses; track wh.id; let i = $index) {
              <option [value]="i" [selected]="port().warehouseService.currentWarehouseId() === wh.id">{{ wh.name }}</option>
            }
          </select>
        </div>
      }
    </div>

    <!-- RIGHT column: Contacts -->
    <div class="pm-col">
      <div class="pm-field pm-field-full">
        <div class="pm-contacts-header">
          <label><i class="pi pi-users"></i> {{ 'USER.CONTACTS' | translate }}</label>
          <button class="pm-add-btn" (click)="contactAdded.emit()">
            <i class="pi pi-plus"></i> {{ 'COMMON.ADD' | translate }}
          </button>
        </div>

        @if (profileContacts().length === 0) {
          <div class="pm-empty-contacts">
            <i class="pi pi-user-plus"></i>
            <span>{{ 'USER.CONTACTS' | translate }}</span>
          </div>
        }

        <div class="pm-contacts-list">
          @for (contact of profileContacts(); track $index; let i = $index) {
            <div class="pm-contact-card">
              <div class="pm-contact-fields">
                <div class="pm-contact-row">
                  <input type="text" class="pm-input pm-input-sm" [(ngModel)]="contact.fullName"
                         [placeholder]="'USER.CONTACT_NAME' | translate" />
                  <select class="pm-select pm-select-sm pm-select-link" [(ngModel)]="contact.relationshipId">
                    <option value="" disabled selected>{{ 'USER.CONTACT_LINK' | translate }}</option>
                    @for (link of parentalLinks(); track link.id) {
                      <option [value]="link.id">{{ link.label }}</option>
                    }
                  </select>
                </div>
                <input type="tel" class="pm-input pm-input-sm" [(ngModel)]="contact.phoneNumber"
                       [placeholder]="'USER.CONTACT_PHONE' | translate" />
              </div>
              <button class="pm-remove-btn" (click)="contactRemoved.emit(i)">
                <i class="pi pi-trash"></i>
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="pm-divider"></div>

  <div class="pm-footer">
    <button class="pm-btn-cancel" (click)="closed.emit()">
      {{ 'COMMON.CANCEL' | translate }}
    </button>
    <button class="pm-btn-save" (click)="saved.emit()" [disabled]="profileSaving()">
      @if (profileSaving()) {
        <i class="pi pi-spin pi-spinner"></i>
      }
      <i class="pi pi-check"></i> {{ 'COMMON.SAVE' | translate }}
    </button>
  </div>
</div>
